module.exports = __webpack_public_path__ + "img/img16.4631f842.png";